@if (isChatOpen) {
  <div class="chat-widget-row" [class.shifted-up]="showButton">
    @if (showWelcome) {
      <div
        class="welcome-bubble"
        role="button"
        tabindex="0"
        (click)="openInput()"
        (keydown.enter)="openInput()"
        (keydown.space)="$event.preventDefault(); openInput()"
      >
        <p><span class="welcome-icon" aria-hidden="true">👋</span> Questions? Ask me!</p>
        <button
          type="button"
          class="welcome-close"
          (click)="$event.stopPropagation(); dismissWelcome()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
              fill="#1D1B20"
            />
          </svg>
        </button>
      </div>
    }

    @if (showChatButton) {
      <div class="suuport-widgets">
        <!-- <button (click)="toggleTheme()">
          <span>{{ isDarkMode ? 'Light Mode' : 'Dark Mode' }}</span>
          <img [src]="isDarkMode ? '/assets/img/logos/website/light-mode.svg' : '/assets/img/logos/website/dark-mode.svg'" loading="lazy" width="22" height="22" alt="Contact support">
        </button> -->

        <button class="chat-btn" (click)="openInput()">
          <span>InfraonAsk</span>
          <img
            src="/assets/img/logos/website/chat-icon.svg"
            loading="lazy"
            width="25"
            height="25"
            alt="Start live chat"
          />
        </button>

        <!-- <button routerLink="/contact-us">
          <span>Contact Us</span>
          <img src="/assets/img/logos/website/contact.svg" loading="lazy" width="22" height="22" alt="Contact support">
        </button>

        <button class="resources-btn" routerLink="/resources">
          <span>Resources</span>
          <img src="/assets/img/logos/website/resources.svg" loading="lazy" width="20" height="22" alt="Resources and documentation">
        </button> -->
      </div>
    }
  </div>
}

<button
  role="button"
  aria-label="scroll to top"
  title="scroll to top"
  (click)="scrollToTop()"
  class="back-to-top"
  [class.visible]="showButton"
>
  <svg
    [ngStyle]="btnColor"
    xmlns="http://www.w3.org/2000/svg"
    height="22"
    viewBox="0 -960 960 960"
    width="22"
    fill="#0D51D9"
  >
    <path d="M440-160v-487L216-423l-56-57 320-320 320 320-56 57-224-224v487h-80Z" />
  </svg>
</button>

@if (isInputOpen) {
  <div
    class="chat-backdrop"
    role="button"
    tabindex="0"
    (click)="closeBackdrop()"
    (keydown.enter)="closeBackdrop()"
    (keydown.space)="$event.preventDefault(); closeBackdrop()"
  >
    <div
      class="chat-panel"
      tabindex="-1"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      @if (showWindow) {
        <div class="chat-window-section" #chatWindow>
          <div class="chat-header">
            <div>
              <img class="avatar" src="/assets/img/logos/website/chat-online.svg" alt="assistant" />
              <p>InfraonAsk <span>- Powered by Infraon</span></p>
            </div>

            <!-- draggable handle -->
            <div class="resize-handle" (mousedown)="startResize($event)"></div>

            <button type="button" class="close-btn" (click)="toggleWindow()">✕</button>
          </div>

          <div class="chat-body" #chatBody>
            @for (m of messages; track $index; let mi = $index) {
              <div class="chat-row" [ngClass]="m.role">
                @if (m.role === 'assistant') {
                  <div class="avatar-wrapper">
                    <img
                      class="avatar"
                      src="/assets/img/logos/website/chat-online.svg"
                      alt="assistant"
                    />
                  </div>
                }

                <div class="bubble-wrapper">
                  @if (!m.typing) {
                    <div class="content-card" [class.with-form]="m.contactForm">
                      <div
                        class="bubble"
                        [innerHTML]="(m.contactForm ? m.displayText || m.text : m.text) | linkify"
                      ></div>

                      @if (m.contactForm) {
                        <div class="contact-form">
                          @if (!m.formSubmitted) {
                            <form (ngSubmit)="submitContactForm(m)" #cf="ngForm">
                              @for (f of m.formFields; track f.key; let fi = $index) {
                                <div class="form-field" [class.phone-field]="f.type === 'tel'">
                                  <div class="field-wrap">
                                    @if (f.type === 'tel') {
                                      <input
                                        id="field-{{ mi }}-{{ fi }}"
                                        type="tel"
                                        placeholder=" "
                                        autocomplete="off"
                                        appIntlTelInput
                                        (countryChange)="onCountryChange(f, $event)"
                                        [(ngModel)]="f.value"
                                        name="field-{{ mi }}-{{ fi }}"
                                        [required]="f.required"
                                        [class.has-error]="f.error"
                                        (blur)="onFieldBlur(f)"
                                      />
                                    } @else {
                                      <input
                                        id="field-{{ mi }}-{{ fi }}"
                                        [type]="f.type"
                                        placeholder=" "
                                        autocomplete="off"
                                        [(ngModel)]="f.value"
                                        name="field-{{ mi }}-{{ fi }}"
                                        [required]="f.required"
                                        [class.has-error]="f.error"
                                        (blur)="onFieldBlur(f)"
                                      />
                                    }
                                    <label class="floating-label" for="field-{{ mi }}-{{ fi }}">{{
                                      f.type === 'tel' ? 'Phone' : f.label
                                    }}</label>
                                  </div>
                                  @if (f.error) {
                                    <div class="field-error">{{ f.error }}</div>
                                  }
                                </div>
                              }
                              <button type="submit" [disabled]="cf.invalid">Submit</button>
                            </form>
                          } @else {
                            <div class="form-submitted-note">
                              ✅ Thanks! Your details have been submitted.
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }

                  @if (m.typing) {
                    <div class="typing-bubble">
                      <span class="thinking-text">Thinking…</span>
                    </div>
                  }

                  <div class="meta-time">{{ m.time }}</div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!-- INPUT AREA -->
      <div class="input-wrapper">
        <input
          #chatInput
          [(ngModel)]="input"
          (keydown.enter)="send()"
          [placeholder]="displayPlaceholder"
        />

        <button (click)="send()">
          <img src="/assets/img/logos/website/send-btn.svg" alt="send button" />
        </button>
      </div>
    </div>
  </div>
}
